import React, { useEffect, useState } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query'

import { formatDate, ROUTES } from '../../shared/constants'
import { getAllData, deleteMany } from '../../lib/RestApi/customApiHandler'

import { useHistory } from 'react-router'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import useDebounce from '../../hooks/useDebounce'
import { toastMessage } from '../../shared/AlertPopup'

export default function Permissions() {
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedValue = useDebounce(searchQuery, 500)

  const { data: permissions, isLoading } = useQuery(['company-permissions', debouncedValue && debouncedValue], () => getAllData('permissions', { searchQuery: debouncedValue }))
  

  let tableBody = []

  if (!isLoading && permissions?.data?.length > 0) {
    tableBody = permissions?.data?.map((item) => {
      return [{ type: 'CHECKBOX', _id: item._id }, { value: item.name }, { value: item.allowed.map((item) => item.module + ',') }, { value: formatDate(item.createdAt) }]
    })
  }

  const layoutProps = {
    heading: 'Manage Permissions',
    url: ROUTES.ADD_SUPER_ADMIN_PERMISSIONS,
    editUrl: `/super-admin/permissions/edit/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaderData: [],
    // filename: 'superAdmins',
    // headers: gs,
    // data: pdfCsvData.headingValues,
    // downloadLoading,
  }

  return (
    <CustomTableLayout
      tableHeadings={['Permission Name', 'Modules', 'Created Date']}
      loading={isLoading}
      tableBody={tableBody}
      //   handleSwitchChange={handleSwitchChange}
      //   handlePageChange={handleChange}
      //   paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => {
        if(deleteMany('permissions', {ids: val}).status === 400){
          return toastMessage('something went wrong', 'ereror');
        }else{
          window.location.reload();       
          setSelected([]) 
        }
 } }
      //   deleteMany={(val, setSelected) => deleteManySuperAdmin({ companyId: val }, setSelected)}
    />
  )
}
